import { dateFormat } from '@carm/shared/constants/const-carm';
import * as dayjs from 'dayjs';

/// convert 'YYYY-MM-DD' string to Date type
String.prototype.carmDateToDate = function(): Date {
  if (this) {
    return dayjs(this, dateFormat).toDate();
  }

  return null;
};

String.prototype.toProperDate = function(): Date {
  if (this) {
    return dayjs(this.formatDate(), dateFormat).toDate();
  }

  return null;
};

/// format a long date string to YYYY-MM-DD
String.prototype.formatDate = function(): string {
  if (this) {
    return dayjs(this).utc().format(dateFormat);
  }

  return '';
};

String.prototype.toNullIfEmpty = function(): string {
  return !!this?.trim() ? this.trim() : null;
};

String.prototype.removeHyphens = function(): string {
  return this.replace(/-/g, '');
}

// Removes most of the ASCII control characters and replaces tab by a space
String.prototype.subSpecialCharacters = function(): string {
  return this.replace(/[\u0000-\u0008\u000e-\u001f\u000b\u000c\u007f]+/g, '').replace(/[\u0009]+/g, ' ');
}

String.prototype.toRouteConst = function(): string {
  return this.replace(/(\/business\/*\d{9}\/program\/*\d{9}[A-Z]{2}\d{4})/g, '');
}

String.prototype.toProgramNumberOnly = function(): string {
  return this.replace(/\d{9}/g, '');
}

String.prototype.extractBusinessNumber = function(): string {
  return this.substring(0, 9);
}

String.prototype.extractProgramCode = function(removeFirstChar: boolean = true): string {
  return this.length === 5 && removeFirstChar ? this.substr(1) : this;
}

String.prototype.toOrphanUrl = function(): string {
  return this.replace('/nb/{NATIVE_BN9}/p/{BN15}', '');
}
